// Legacy mock.js - maintained for backward compatibility with QuotePage (FROZEN)
// New pages should import from ../config/business.js instead

export const mockData = {
  business: {
    name: 'Thrifty Move',
    legalName: 'DV Amur Services Pty Ltd',
    tradingAs: 'Thrifty Move',
    phone: '1800 233 023',
    email: 'info@thrifty-move.com.au',
    abn: '47701703344',
    address: '1230b North Road, Oakleigh South VIC 3167',
    location: 'Melbourne, VIC',
    serviceArea: 'All across Melbourne and suburbs',
    tagline: 'Affordable & Reliable Moving Services Across Melbourne',
    description: 'Family-owned Melbourne removal company focused on clear pricing, reliable communication and careful handling.',
    bookingLink: '/quote'
  },
  services: [
    {
      id: 1,
      title: 'Home Moves',
      description: 'Complete residential moving services for homes of all sizes across Melbourne.',
      icon: 'Home'
    },
    {
      id: 2,
      title: 'Office Moves',
      description: 'Professional office relocation with minimal disruption to your business.',
      icon: 'Briefcase'
    },
    {
      id: 3,
      title: 'Furniture Delivery',
      description: 'Safe and efficient furniture delivery and assembly services.',
      icon: 'Sofa'
    },
    {
      id: 4,
      title: 'Local Removals',
      description: 'Quick and affordable local moving services within Melbourne suburbs.',
      icon: 'Truck'
    }
  ],
  testimonials: [
    {
      id: 1,
      name: 'Sarah Mitchell',
      location: 'Richmond',
      rating: 5,
      text: 'Fantastic service! The father and son team were professional, careful with our furniture, and very affordable. Highly recommend!',
      date: '2024-12-15'
    },
    {
      id: 2,
      name: 'James Thompson',
      location: 'Brunswick',
      rating: 5,
      text: 'Used Thrifty Move for our office relocation. They were punctual, efficient, and made the whole process stress-free.',
      date: '2024-11-28'
    },
    {
      id: 3,
      name: 'Emma Wilson',
      location: 'St Kilda',
      rating: 5,
      text: 'Best removalists in Melbourne! Great prices and they treated our belongings like their own. Will use again.',
      date: '2024-10-20'
    }
  ],
  socialMedia: {
    facebook: 'https://facebook.com/thriftymove',
    instagram: 'https://instagram.com/thriftymove'
  }
};
